export const FONT_FAMILY = 'Arial' // 'Barlow'
export const MINIMUM_FONT_SIZE = 10

const headerStyle = {
  fontWeight: 700,
  fontSize: '2rem'
}

export const typography = {
  fontLight: {
    fontFamily: FONT_FAMILY,
    fontWeight: 300,
    fontSize: '1rem'
  },
  font: {
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    fontSize: '1rem'
  },
  fontMedium: {
    fontFamily: FONT_FAMILY,
    fontWeight: 500,
    fontSize: '1rem'
  },
  fontSemiBold: {
    fontFamily: FONT_FAMILY,
    fontWeight: 600,
    fontSize: '1rem'
  },
  fontBold: {
    fontFamily: FONT_FAMILY,
    fontWeight: 700,
    fontSize: '1rem'
  },
  header1: {
    ...headerStyle
  },
  header2: {
    ...headerStyle,
    fontSize: '1.72rem'
  },
  header3: {
    ...headerStyle,
    fontSize: '1.28rem'
  }
}
